// Setup Params
const SELECTOR_CARD = ".PackCard";
const CTA_THRESHOLD = 0.6;
const CTA_RESET_THRESHOLD = 0.5;
const CARD_TILT_DEGREES = 7;
const MQ_CARD_EFFECTS = window.matchMedia("(min-width: 768px) and (hover: hover) and (pointer: fine)");

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function isCardEffectEnabled() {
    return MQ_CARD_EFFECTS.matches;
}
function setCardReflection(card, px, py) {
    const clampedY = clamp(py, 0, 1);
    const clampedX = clamp(px, 0, 1);
    card.style.setProperty("--reflect-y", `${clampedY * 100}%`);
    card.style.setProperty("--reflect-x", `${clampedX * 100}%`);
}

function setCardTilt(card, px, py) {
    // this is disabled for now with the intention to re-enable it later
    return false;
    const normalizedY = clamp(py, 0, 1);
    const normalizedX = clamp(px, 0, 1);
    const tiltY = (normalizedY - 0.5) * 2; // -1 to 1
    const tiltX = (normalizedX - 0.5) * 2; // -1 to 1
    const rotateX = tiltY * CARD_TILT_DEGREES; // max tilt in degrees
    const rotateY = tiltX * ( CARD_TILT_DEGREES * 0.66 ) * -1; // max tilt in degrees

    card.style.setProperty("--card-rotate-x", `${rotateX}deg`);
    card.style.setProperty("--card-rotate-y", `${rotateY}deg`);
}

function setCardCTAState(card, isActive) {
    card.classList.toggle("is-cta-active", isActive);
}

function resetCard(card) {
    card.classList.remove("is-hovered");
    setCardCTAState(card, false);
    setCardReflection(card, 0.5);
    setCardTilt(card, 0.5);
}

function onPointerEnter(event) {
    if (!isCardEffectEnabled()) return;
    const card = event.target.closest( SELECTOR_CARD );
    if( !card ) { return; }
    card.classList.add("is-hovered");
}

function onPointerMove(event) {
    if (!isCardEffectEnabled()) return;
    const card = event.target.closest( SELECTOR_CARD );
    if( !card ) { return; }

    const rect = card.getBoundingClientRect();
    const py = clamp((event.clientY - rect.top) / rect.height, 0, 1);
    const px = clamp((event.clientX - rect.left) / rect.width, 0, 1);

    setCardReflection(card, px, py);
    setCardTilt(card, px, py);

    // CTA logic
    const isCTAActive = card.classList.contains("is-cta-active");

    if (!isCTAActive && py >= CTA_THRESHOLD) {
        setCardCTAState(card, true);
    } else if (isCTAActive && py <= CTA_RESET_THRESHOLD) {
        setCardCTAState(card, false);
    }

}

function onPointerLeave(event) {
    if (!isCardEffectEnabled()) return;
    const card = event.target.closest( SELECTOR_CARD );
    if( !card ) { return; }

    card.classList.remove("is-hovered");
    setCardCTAState(card, false);
    setCardReflection(card, 0.5, 0.5);
    setCardTilt(card, 0.5, 0.5);
}

function setupCard(card) {
    card.addEventListener("pointerenter", onPointerEnter);
    card.addEventListener("pointermove", onPointerMove );
    card.addEventListener("pointerleave", onPointerLeave);
}

function init() {

    const Cards = document.querySelectorAll( SELECTOR_CARD );

    if (!Cards.length) return;

    // Setup cards
    Cards.forEach(setupCard);

    // Listen for media query changes to reset card states when disabling effects
    MQ_CARD_EFFECTS.addEventListener("change", () => {
        if (!cardEffectMQ.matches) {
            Cards.forEach( resetCard );
        }
    });
}

// Run when the DOM is ready
// Check if `window.onload` has already fired
if (document.readyState === "complete") {
    init(); // Page is already fully loaded, run immediately
} else {
    window.onload = init; // Otherwise, wait for `window.onload`
}